import React from 'react';

export default function AdminSearch({ value, onChange, onSearch, placeholder = 'Search records' }) {
  const submit = (event) => {
    event.preventDefault();
    onSearch(value.trim());
  };

  const clear = () => {
    onChange('');
    onSearch('');
  };

  return (
    <form onSubmit={submit} className="flex w-full sm:w-80 h-10 border border-[#E0D6CC] bg-white rounded overflow-hidden focus-within:border-[#C49A45]">
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="min-w-0 flex-1 px-3 text-xs text-[#2B1810] placeholder-[#8A796C] outline-none"
        aria-label={placeholder}
      />
      {value && (
        <button type="button" onClick={clear} className="w-9 flex items-center justify-center text-[#8A796C] hover:text-red-700" title="Clear search" aria-label="Clear search">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
        </button>
      )}
      <button type="submit" className="w-10 flex items-center justify-center bg-[#2B1810] text-white hover:bg-[#C49A45]" title="Search" aria-label="Search">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7" /><path d="M20 20l-4-4" /></svg>
      </button>
    </form>
  );
}
